import { render, staticRenderFns } from "./profile.panel.vue?vue&type=template&id=068efb77&scoped=true"
import script from "./profile.panel.vue?vue&type=script&lang=js"
export * from "./profile.panel.vue?vue&type=script&lang=js"
import style0 from "./profile.panel.vue?vue&type=style&index=0&id=068efb77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068efb77",
  null
  
)

export default component.exports